import { render, staticRenderFns } from "./DoctorsPanel.vue?vue&type=template&id=3bde7ba0&"
import script from "./DoctorsPanel.vue?vue&type=script&lang=js&"
export * from "./DoctorsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports